export class EventWorkflowUpdateModel {
    approved: boolean;
    comment: string;
    currentStatus: number;
}